// ============================================================================
// TierBadge · v2.7.10
// ============================================================================
// Reusable loyalty-tier pill matching the precious-metal palette used on the
// public Welcome banner. Renders nothing for `new` / null / missing tiers so
// the caller can drop it inline without conditional wrapping.
//
// Props:
//   - tier:        "gold" | "silver" | "bronze" | "new" | undefined
//   - label:       optional explicit label (falls back to capitalized tier)
//   - tripCount:   optional, used in title tooltip
//   - size:        "xs" (default) | "sm" — controls font + padding
// ============================================================================
import React from "react";

const TIER_CLASSES = {
  gold:   "bg-gradient-to-r from-yellow-400 to-amber-500 text-zinc-950",
  silver: "bg-gradient-to-r from-zinc-300 to-zinc-400 text-zinc-950",
  bronze: "bg-gradient-to-r from-amber-700 to-orange-800 text-amber-100",
};

const SIZE_CLASSES = {
  xs: "text-[9px] px-1.5 py-0.5",
  sm: "text-[10px] px-2 py-0.5",
};

export default function TierBadge({ tier, label, tripCount, size = "xs" }) {
  if (!tier || tier === "new") return null;
  const cls = TIER_CLASSES[tier];
  if (!cls) return null;
  const text = (label || tier).toString().toUpperCase();
  const title =
    tier === "gold"
      ? `${tripCount ?? "25+"} trips — top-tier rider`
      : tier === "silver"
      ? `${tripCount ?? "10+"} trips — frequent rider`
      : `${tripCount ?? "1-9"} trips — building loyalty`;
  return (
    <span
      data-testid={`tier-badge-${tier}`}
      title={title}
      className={`inline-flex items-center font-extrabold uppercase tracking-widest rounded ${cls} ${SIZE_CLASSES[size] || SIZE_CLASSES.xs}`}
    >
      ★ {text}
    </span>
  );
}
